import { Payload, Types } from 'states/dux/user/types'
import { Action } from 'states/types'

const initialState: Payload = {
  id: 0,
  firstName: 'Un-authenticated',
  lastName: 'User',
  fullName: 'Un-authenticated User',
  groups: [],
  contactList: [],
  email: '',
  address: '',
  authenticated: false,
  image: undefined,
  accessToken: undefined,
  refreshToken: undefined,
  loading: false
}

const reducer = (state = initialState, action: Action<Payload>): Payload => {
  const { type, payload } = action
  switch (type) {
    case Types.SET: {
      return payload
    }
    case Types.UPDATE: {
      return { ...state, ...payload }
    }
    default:
      return state
  }
}

export { reducer }

export default reducer
